import { route } from 'quasar/wrappers'
import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router'
import routes from './routes'

import { useResultPageStore } from "../stores/resultPageStore";

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory)

  const Router = createRouter({
    scrollBehavior:
      (to, from, savedPosition) => {
        if (to.hash) {
          return { el: to.hash }
        } else {
          return { left: 0, top: 0 }
        }
      },
    routes,
    mode: 'abstract',

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE)
  })

  const store = useResultPageStore();
  Router.beforeEach((to, from, next) => {

    if (!store.mandantId && (to.params.mandantId || to.meta.mandantId)) {
      if (to.meta.mandantId) {
        store.mandantId = to.meta.mandantId;
        store.addMandantIdToPath = false;
      } else {
        store.mandantId = to.params.mandantId;
        store.addMandantIdToPath = true;
      }
    }

    if (!store.docuId && (to.params.docuId || to.meta.docuId)) {
      if (to.meta.docuId) {
        store.docuId = to.meta.docuId;
        store.addDocuIdToPath = false;
      } else {
        store.docuId = to.params.docuId;
        store.addDocuIdToPath = true;
      }
    }
    if (!store.sesId && to.query.ses) {
      store.sesId = to.query.ses;
    }

    if (to.name == 'NotFound') {
      next();
      return;
    }

    if (store.settings.loaded) {

      if (to.name == 'Settings' && !store.settings.loggedIn) {
        Router.push({ name: 'Home', params: { mandantId: store.mandantId, docuId: store.docuId } });
        return;
      }
    } else {

      store.loadSettings().then(() => {
        if (store.settings.isNew && to.query.name) {
          store.settings.project_name = to.query.name;
        }
        if (store.settings.loggedIn && store.settings.isNew && to.name != 'Settings') {

          // store.settings.project_url = 'https://public.vadok.de/'+to.query.project;
          store.settings.project_name = to.query.name;

          Router.push({ name: 'Settings', query: { ses: to.query.ses }, params: { mandantId: store.mandantId, docuId: store.docuId } });
        }
        else {
          Router.push(to.fullPath);
        }
        return;
      }).catch(() => {
        Router.push({
          name: 'NotFound', params: { mandantId: store.mandantId, docuId: store.docuId }
        });
      });
      return;
    }

    if (!store.currentMenu) {
      store.loadMenu().then(() => {
        Router.push(to.fullPath);
      });
      return;
    }

    if (to.params.pageId?.length) {
      if (to.params.pageId.length) {
        store.load(to.params.pageId).then((loadedPath) => {
          var targetPath = '/' + to.params.pageId.join('/')

          if (!store.addMandantIdToPath)
            loadedPath = loadedPath.replace(store.mandantId + '/', '');
          if (!store.addDocuIdToPath)
            loadedPath = loadedPath.replace('/' + store.docuId, '');

          if (to.fullPath != loadedPath) {
            Router.push(loadedPath);
            return;
          }
        });
      } else {
        Router.push({ name: 'Home' });
      }
    }
    next()
  });

  return Router
})
